import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClinicalDiagnosticsSection from './components/ClinicalDiagnosticsSection';
import BiomarkerComparisonSection from './components/BiomarkerComparisonSection';
import SpecialtyPotentialSection from './components/SpecialtyPotentialSection';
import ScienceSection from './components/ScienceSection';
import PlatformSection from './components/PlatformSection';
import MarketImpactSection from './components/MarketImpactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <ClinicalDiagnosticsSection />
      <BiomarkerComparisonSection />
      <SpecialtyPotentialSection />
      <ScienceSection />
      <PlatformSection />
      <MarketImpactSection />
      <Footer />
    </main>
  );
}